<template>
  <div class="fixed_tools">
    <div v-if="visible" class="info">
      <div class="arrow" :style="{ top: arrowTop + 'px' }"></div>
      <div class="info_container" v-if="current === 1">
        <img class="qrcode" :src="qrcode1" alt="骆驼讲保微信公众号二维码" />
        <div class="title mb15">关注骆驼讲保</div>
        <div class="content_info">回复“方案”，免费获取保险专家1对1咨询</div>
        <div class="icon-close" @click="closeQrCode">
          <img src="@/assets/images/close.png" alt="" />
        </div>
      </div>
      <div class="info_container info_container_bg" v-if="current === 2">
        <div class="title_bg mt21">客服电话</div>
        <div class="content_bg">400-099-9559</div>
        <div class="title_bg mt21">工作时间</div>
        <div class="content_bg">9:00-18:00</div>
        <div class="content_bg">（工作日）</div>
      </div>
      <div class="info_container" v-if="current === 3">
        <img
          class="qrcode"
          src="@/assets/images/versionNew/adviser_new.png"
          alt="顾问二维码"
        />
        <div class="title mb15">添加顾问好友</div>
        <div class="content_info">专属保险顾问 全程为您服务</div>
      </div>
    </div>
    <div class="tools">
      <div
        class="tool"
        v-for="key in tools"
        :key="key"
        @mouseover="() => showInfo(key)"
        @mouseout="() => (visible = false)"
      >
        <div :class="['tool_icon', `tool_icon${key}`]"></div>
      </div>
      <div class="tool" @click="gotoEnent">
        <div class="tool_icon tool_icon4"></div>
      </div>
    </div>
  </div>
</template>
<script>
const baseTop = 20;
export default {
  name: "AbsoluteTools",
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      interval: null,
      tools: [1, 2, 3],
      visible: false,
      arrowTop: baseTop,
      current: 1
    };
  },
  mounted() {
    const closeQrCode = sessionStorage.getItem("show_qr");
    if (closeQrCode === "1") {
      this.visible = false;
    } else {
      this.visible = true;
    }
  },
  computed: {
    qrcode1() {
      let url = require("@/assets/images/versionNew/qrcode_new.jpg");
      // switch (this.type) {
      //   case 1:
      //     url = require("@/assets/images/qrcodes/home_fixed_attention.jpg");
      //     break;
      //   case 2:
      //     url = require("@/assets/images/qrcodes/consult_fixed_attention.jpg");
      //     break;
      //   case 31:
      //     url = require("@/assets/images/qrcodes/information_fixed_attention31.jpg");
      //     break;
      //   case 32:
      //     url = require("@/assets/images/qrcodes/information_fixed_attention32.jpg");
      //     break;
      //   case 33:
      //     url = require("@/assets/images/qrcodes/information_fixed_attention33.jpg");
      //     break;
      //   case 41:
      //     url = require("@/assets/images/qrcodes/about_fixed_attention41.jpg");
      //     break;
      //   case 42:
      //     url = require("@/assets/images/qrcodes/about_fixed_attention42.jpg");
      //     break;
      //   case 43:
      //     url = require("@/assets/images/qrcodes/about_fixed_attention43.jpg");
      //     break;
      //   case 5:
      //     url = require("@/assets/images/qrcodes/tagsmap_fixed_attention.jpg");
      //     break;
      //   case 6:
      //     url = require("@/assets/images/qrcodes/sitemap_fixed_attention.jpg");
      //     break;
      //   case 99:
      //     url = this.$store.state.floatQrcode;
      //     break;
      // }
      return url;
    },
    qrcode2() {
      let url = "";
      //switch (this.type) {
      // 	case 1:
      // 		url = require('@/assets/images/qrcodes/home_fixed_add.png');
      // 		break;
      // 	case 2:
      // 		url = require('@/assets/images/qrcodes/consult_fixed_add.png');
      // 		break;
      // 	case 31:
      // 		url = require('@/assets/images/qrcodes/information_fixed_add31.png');
      // 		break;
      // 	case 32:
      // 		url = require('@/assets/images/qrcodes/information_fixed_add32.png');
      // 		break;
      // 	case 33:
      // 		url = require('@/assets/images/qrcodes/information_fixed_add33.png');
      // 		break;
      // 	case 41:
      // 		url = require('@/assets/images/qrcodes/about_fixed_add41.png');
      // 		break;
      // 	case 42:
      // 		url = require('@/assets/images/qrcodes/about_fixed_add42.png');
      // 		break;
      // 	case 43:
      // 		url = require('@/assets/images/qrcodes/about_fixed_add43.png');
      // 		break;
      // 	case 99:
      // 		url = require('@/assets/images/qrcodes/about_fixed_add43.png');
      // 		break;
      // }
      return url;
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    closeQrCode() {
      this.visible = false;
      sessionStorage.setItem("show_qr", 1);
    },
    showInfo(key) {
      this.current = key;
      this.arrowTop = baseTop + (key - 1) * 50;
      this.visible = true;
      let sensorData = {};
      switch (key) {
        case 1:
          sensorData = {
            url: window.location.href,
            tgt_name: "PC官网_悬浮_公众号",
            tgt_event_id: "bxWeb_hover_wechat_imp"
          };
          this.$point("h5_element_imp", sensorData);
          break;
        case 2:
          sensorData = {
            url: window.location.href,
            tgt_name: "PC官网_悬浮_客服电话",
            tgt_event_id: "bxWeb_hover_phone_imp"
          };
          this.$point("h5_element_imp", sensorData);
          break;
        case 3:
          sensorData = {
            url: window.location.href,
            tgt_name: "PC官网_悬浮_咨询服务",
            tgt_event_id: "bxWeb_hover_consult_imp"
          };
          this.$point("h5_element_imp", sensorData);
          break;
        default:
          break;
      }
    },
    gotoEnent() {
      const sensorData = {
        url: window.location.href,
        tgt_name: "PC官网_悬浮_回顶部",
        tgt_event_id: "bxWeb_hover_top"
      };
      this.$point("h5_clk", sensorData);

      let distanceY = window.pageYOffset;
      let i = 0;
      this.interval = setInterval(() => {
        let next = Math.floor(
          this.easeInOutQuad(10 * i, distanceY, -distanceY, 500)
        );
        if (next <= 0) {
          window.scrollTo(0, 0);
          clearInterval(this.interval);
        } else {
          window.scrollTo(0, next);
        }
        i++;
      }, 17);
    },
    /*
      缓动公式（Tween算法）
       t: 动画已经执行的时间（实际上时执行多少次/帧数）
       b: 起始位置
       c: 终止位置
       d: 从起始位置到终止位置的经过时间（实际上时执行多少次/帧数）
    */
    easeInOutQuad(t, b, c, d) {
      // 判断当前时间是否总在总时间的一半以内，是的话执行缓入函数，否则的话执行缓出函数
      if ((t /= d / 2) < 1) {
        return (c / 2) * t * t + b;
      } else {
        // 将总长度设置为一半，并且时间从当前开始递减，对图像进行垂直向上平移
        return (-c / 2) * (--t * (t - 2) - 1) + b;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.fixed_tools {
  position: fixed;
  right: 9px;
  bottom: 150px;
  height: 202px;
  z-index: 999;
  .info {
    float: left;
    margin-right: 12px;
    width: 142px;
    height: 202px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 46px -4px rgba(137, 154, 230, 0.3);
    position: relative;
    .arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: rgba(255, 255, 255, 1);
      z-index: 1;
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
    .info_container {
      padding: 25px;
      &.info_container_bg {
        padding: 25px 18px;
      }
      .qrcode {
        width: 88px;
        height: 88px;
      }
      .title {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(59, 59, 88, 1);
        line-height: 17px;
      }
      .title_bg {
        font-size: 14px;
        line-height: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(59, 59, 88, 1);
      }
      .mt21 {
        margin-top: 21px;
      }
      .mb15 {
        margin-bottom: 15px;
      }
      .content_info {
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(105, 108, 141, 1);
        line-height: 18px;
        text-align: center;
      }
      .icon-close {
        position: absolute;
        cursor: pointer;
        top: 0px;
        right: 0px;
        padding: 8px;
        img {
          width: 10px;
          height: 10px;
        }
      }
      .content_bg {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(105, 108, 141, 1);
        line-height: 20px;
      }
    }
  }
  .tools {
    float: left;
    width: 46px;
    background: #fff;
    box-shadow: 0px 0px 46px -4px rgba(137, 154, 230, 0.3);
    .tool {
      height: 50.5px;
      padding: 10px 8px;
      .tool_icon {
        cursor: pointer;
        width: 30px;
        height: 30px;
        &.tool_icon1 {
          background: url("~@/assets/images/version/tool1.png") no-repeat;
          background-size: cover;
        }
        &.tool_icon2 {
          background: url("~@/assets/images/version/tool2.png") no-repeat;
          background-size: cover;
        }
        &.tool_icon3 {
          background: url("~@/assets/images/version/tool3.png") no-repeat;
          background-size: cover;
        }
        &.tool_icon4 {
          background: url("~@/assets/images/version/tool4.png") no-repeat;
          background-size: cover;
        }
      }
    }
    .tool:hover {
      background: #fec341;
      .tool_icon1 {
        background: url("~@/assets/images/version/toolon1.png") no-repeat;
        background-size: cover;
      }
      .tool_icon2 {
        background: url("~@/assets/images/version/toolon2.png") no-repeat;
        background-size: cover;
      }
      .tool_icon3 {
        background: url("~@/assets/images/version/toolon3.png") no-repeat;
        background-size: cover;
      }
      .tool_icon4 {
        background: url("~@/assets/images/version/toolon4.png") no-repeat;
        background-size: cover;
      }
    }
  }
}
</style>
